var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"dense":"","label":"Выбор таймзоны","outlined":"","items":_vm.timeZones,"hide-details":""},model:{value:(_vm.localeTimeZone),callback:function ($$v) {_vm.localeTimeZone=$$v},expression:"localeTimeZone"}})}
var staticRenderFns = []

export { render, staticRenderFns }